import type { PromotedCategoryType } from "@/core/services/types/promoted-category.types";
import type { TaxonomyItem } from "@/core/services/types/taxonomy.types";

export function promotedTypeForTaxonomyItem(
  item: TaxonomyItem,
): PromotedCategoryType | null {
  if (item.category === "ART_FORM") return "artForms";
  if (item.category === "ARTISTIC_PERIOD") {
    return item.parent_id == null
      ? "artisticPeriods"
      : "artisticPeriodsSubCats";
  }
  return null;
}
